<div class="dialog-container">
  <div class="title-bar">
    <div class="title">{{getApproveText()}} {{data.compass.name}}</div>
    <mat-progress-spinner *ngIf="working" class="spinner" color="primary" mode="indeterminate" diameter="21">
    </mat-progress-spinner>
  </div>
  <div *ngIf="!data.approve" class="dialog-body input-area">
    <div class="input-container double">
      <div class="label-line">
        <span class="label">Reason</span>
      </div>
      <div class="input-inner-container">
        <label for="reason" class="hitbox text"></label>
        <textarea textareaAutoheight id="reason" class="input" maxlength="255"
          placeholder="Reject Reason" [(ngModel)]="reason" [disabled]="working"></textarea>
      </div>
    </div>
  </div>
  <div *ngIf="data.approve" class="dialog-body input-area">
    <div class="input-container double">
      <div class="label-line">
        <span class="label">Stripe Key</span>
      </div>
      <input type="text" class="input" placeholder="Stripe Key" [(ngModel)]="stripeKey" [disabled]="working" />
    </div>
    <div class="input-container double">
      <div class="label-line">
        <span class="label">Tags</span>
        <button mat-button class="text-button label-info-button" tabindex="-1" title="All Tags"
          (click)="showAllTags($event)">
          <img src="assets/content-icon/ic-01.svg" class="icon" />
        </button>
      </div>
      <div class="input bubbles">
        <div *ngFor="let tag of sortedTags; index as i" class="bubble with-button" [ngClass]="{disabled: working}">
          <input [inputAutowidth]="52" type="text" maxlength="127" class="bubble-input" placeholder="Tag" [ngModel]="tag.text" disabled />
          <button mat-button class="button text-button" tabindex="-1" [disabled]="working" (click)="removeTag(i)">
            <img src="assets/content-icon/ic-05.svg" class="icon" />
          </button>
        </div>
        <button mat-button class="bubble button" [disabled]="working" (click)="addTag()">
          <img src="assets/content-icon/ic-04.svg" class="icon" />
        </button>
      </div>
    </div>
    <div class="input-container double no-underline input-area" *ngFor="let tag of tags; index as i">
      <div class="input-container">
        <div class="label-line">
          <span class="label">Tag Name</span>
        </div>
        <input (optionSelected)="tagSelected($event, i)" type="text" class="input" maxlength="127" placeholder="Tag Name"
          [(ngModel)]="tag.text" [disabled]="working" [simpleAutocomplete]="tagAutocomplete" (ngInit)="autofocusInput($event)"
          (focus)="setFilter(tag.text)" (blur)="tagNameBlurred(i)" (inputChange)="setFilter($event); sortTags()" />
        <span *ngIf="tagIsNew(tag.text) && !isLoading()" class="reminder-message">New tag</span>
      </div>
      <div class="input-container">
        <div class="label-line">
          <span class="label">Tag Priority</span>
        </div>
        <input numberInput [int]="false" type="text" class="input" placeholder="Tag Priority" [(ngModel)]="tag.priority" [disabled]="working" (inputChange)="sortTags()" />
      </div>
    </div>
    <div class="input-container" [ngClass]="{double: !hasPrimarySource()}">
      <div class="label-line">
        <span class="label">Primary Source</span>
      </div>
      <input type="text" class="input" maxlength="255" placeholder="Primary Source" [(ngModel)]="source" [disabled]="working" />
    </div>
    <div *ngIf="hasPrimarySource()" class="input-container">
      <div class="label-line">
        <span class="label">Primary Source Slug</span>
      </div>
      <input type="text" class="input" maxlength="32" placeholder="Primary Source" [(ngModel)]="sourceSlug" [disabled]="working" />
    </div>
    <div class="input-container">
      <div class="label-line">
        <span class="label">Provider Link</span>
      </div>
      <input type="text" class="input" maxlength="255" placeholder="Provider Link" [(ngModel)]="link" [disabled]="working" />
    </div>
    <div class="input-container">
      <div class="label-line">
        <span class="label">Provider Slug</span>
      </div>
      <input type="text" class="input" maxlength="32" placeholder="Provider Slug" [(ngModel)]="providerSlug" [disabled]="working" />
    </div>
  </div>
  <div class="buttons">
    <button mat-button class="text-button secondary" [disabled]="working" [mat-dialog-close]>Cancel</button>
    <button mat-button class="text-button" [disabled]="!canSubmit()" (click)="submit()">{{getApproveText()}}</button>
  </div>
</div>
<div class="backdrop" [ngClass]="{showing: allTagsShowing}" (click)="hideAllTags()">
  <div #allTagsPopover class="popover" [ngClass]="{showing: allTagsShowing}" [style]="allTagsPosition"
    (click)="$event.stopPropagation()">
    <div class="popover-content">
      <div class="header">All Tag Priorities</div>
      <div class="text" *ngFor="let priorityData of allTagsPriorityList"><span class="bold">{{priorityData.priority}}:</span> {{arrayToString(priorityData.tags)}}</div>
    </div>
  </div>
  <div class="popover-arrow" [ngClass]="{showing: allTagsShowing}" [style]="allTagsArrowPosition"></div>
</div>
